/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Toast_Error2Inputs */

const en_settings_reportingapikeys_toast_error2 = /** @type {(inputs: Settings_Reportingapikeys_Toast_Error2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The request failed. Please try again.`)
};

/**
* | output |
* | --- |
* | "The request failed. Please try again." |
*
* @param {Settings_Reportingapikeys_Toast_Error2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_toast_error2 = /** @type {((inputs?: Settings_Reportingapikeys_Toast_Error2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Toast_Error2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_toast_error2(inputs)
});
export { settings_reportingapikeys_toast_error2 as "settings_reportingApiKeys_toast_error" }